
const digest = '000bfad814a787f8dd04d4575da835162abf2abc412bc9cb0aedbc7fce04fc8e';
const classes = {"wrapper":"_wrapper_10jpu_1","content":"_content_10jpu_12","controls":"_controls_10jpu_19"};
const css = `._wrapper_10jpu_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_10jpu_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_10jpu_1 ._content_10jpu_12 {
  display: flex;
  align-items: center;
  padding: 24px;
  font-size: 14px;
  font-weight: 500;
}
._wrapper_10jpu_1 ._controls_10jpu_19 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  padding: 24px;
  border-left: 1px solid #eaedf3;
  flex-wrap: wrap;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  